<template>
    <div class="root">
      <div class="countdown">
      <div class="timer">
        <div class="time-box">
          <div class="time-container">
            <div class="digit">{{ days[0] }}</div>
            <div class="digit">{{ days[1] }}</div>
          </div>
          <p>Days</p>
        </div>
        <div class="time-box">
          <div class="time-container">
            <div class="digit">{{ hours[0] }}</div>
            <div class="digit">{{ hours[1] }}</div>
          </div>
          <p>Hours</p>
        </div>
        <div class="time-box">
          <div class="time-container">
            <div class="digit">{{ minutes[0] }}</div>
            <div class="digit">{{ minutes[1] }}</div>
          </div>
          <p>Minutes</p>
        </div>
        <!-- <div class="time-box">
          <div class="time-container">
            <div class="digit">{{ seconds[0] }}</div>
            <div class="digit">{{ seconds[1] }}</div>
          </div>
          <p>Seconds</p>
        </div> -->
      </div>
    </div>
    </div>
  </template>
  
  <script>
  export default {
    props: ['targetDate'],
    data () {
      return {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
      }
    },
    mounted () {
      this.countdown()
      this.interval = setInterval(this.countdown, 1000)
    },
    beforeDestroy () {
      clearInterval(this.interval)
    },
    methods: {
      countdown () {
        const now = new Date().getTime()
        const target = new Date(this.targetDate).getTime()
        const distance = target - now
        if (distance < 0) {
          clearInterval(this.interval)
          return
        }
        this.days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, '0')
        this.hours = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0')
        this.minutes = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0')
        this.seconds = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, '0')
      }
    }
  }
  </script>
<style scoped>
.countdown {
  text-align: center;
  color: #ffffff;
  background: transparent;
  font-family: Arial, sans-serif;
}
.message p {
  margin: 0;
  font-size: 2rem;
}
.message p:nth-child(2) {
  font-size: 3rem;
  font-weight: bold;
}
.timer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.time-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.time-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 5px;
}
.digit {
  font-size: x-large !important;
  background: #333;
  color: #ed2d2f;
  font-size: 2.5rem;
  width: 30px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 2px;
  border-radius: 5px;
}
.time-box p {
  font-size: small;
  margin: 5px 0 0;
  color: #ffffff;
}
@media screen and (max-width: 1200px) {
  .time-box {
  margin: 0 3px;
}
.digit {
  width: 20px;
  height: 30px;
}
.time-box p {
  font-size: x-small;
  margin: 5px 0 0;
  color: #ffffff;
}
}
@media screen and (max-width: 1024px) {
  .time-box {
  margin: 0 3px;
}
.digit {
  width: 20px;
  height: 30px;
}
.time-box p {
  font-size: x-small;
  margin: 5px 0 0;
  color: #ffffff;
}
}

@media only screen and (max-width: 850px) {
  .time-box {
  margin: 0 5px;
}
.digit {
  width: 20px;
  height: 30px;
}
.time-box p {
  font-size: small;
  margin: 5px 0 0;
  color: #ffffff;
}
}
@media screen and (max-width: 480px) {
.time-box {
  margin: 0 3px;
}
.digit {
  width: 20px;
  height: 30px;
}
.time-box p {
  font-size: x-small;
  margin: 5px 0 0;
  color: #ffffff;
}
}
</style>



// WEBPACK FOOTER //
// CountdownTimer.vue?69e5a790